export default __webpack_public_path__ + "static/media/swooshBlack.140c5f0c.svg";